(function(){
  'use strict';
  var d=document, root=d.documentElement;
  root.classList.add('js');
  function ready(fn){ if(d.readyState!=='loading'){fn();} else {d.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    requestAnimationFrame(function(){ root.classList.add('is-ready'); });
    var header=d.querySelector('.site-header');
    var onScroll=function(){ if(header){ header.classList.toggle('is-scrolled', window.scrollY>8); } };
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

    var reveals=d.querySelectorAll('[data-reveal]');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      },{rootMargin:'0px 0px -8% 0px',threshold:0.08});
      reveals.forEach(function(el){ io.observe(el); });
    } else { reveals.forEach(function(el){ el.classList.add('is-in'); }); }

    d.querySelectorAll('[data-gallery]').forEach(function(g){
      var track=g.querySelector('.gallery__track');
      var slides=[].slice.call(g.querySelectorAll('.gallery__slide'));
      var thumbs=[].slice.call(g.querySelectorAll('.gallery__thumb'));
      var count=g.querySelector('[data-gallery-count]');
      if(!track||!slides.length){return;}
      var current=0;
      function scrollBehavior(){ return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      function set(i){
        current=i;
        thumbs.forEach(function(t,j){ t.setAttribute('aria-current', j===i?'true':'false'); });
        if(count){ count.textContent=(i+1)+' / '+slides.length; }
        var t=thumbs[i]; if(t && t.parentNode){ var p=t.parentNode; var horizontal=p.scrollWidth>p.clientWidth+2;
          if(horizontal){ p.scrollTo({left:t.offsetLeft-p.clientWidth/2+t.clientWidth/2,behavior:scrollBehavior()}); } }
      }
      function go(i){
        i=(i+slides.length)%slides.length;
        track.scrollTo({left:slides[i].offsetLeft-track.offsetLeft,behavior:scrollBehavior()});
        set(i);
      }
      thumbs.forEach(function(t,i){ t.addEventListener('click',function(){ go(i); }); });
      var prev=g.querySelector('[data-gallery-prev]'), next=g.querySelector('[data-gallery-next]');
      if(prev){ prev.addEventListener('click',function(){ go(current-1); }); }
      if(next){ next.addEventListener('click',function(){ go(current+1); }); }
      var tm;
      track.addEventListener('scroll',function(){ clearTimeout(tm); tm=setTimeout(function(){
        var i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth)); if(i!==current && i>=0 && i<slides.length){ set(i); }
      },80); },{passive:true});
      track.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){ e.preventDefault(); go(current+1);} if(e.key==='ArrowLeft'){ e.preventDefault(); go(current-1);} });
      set(0);
    });

    var sticky=d.querySelector('[data-sticky-buy]');
    var anchors=d.querySelectorAll('[data-buy-anchor]');
    if(sticky && anchors.length && 'IntersectionObserver' in window){
      var visible=new Set();
      var so=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ visible.add(e.target);} else { visible.delete(e.target);} });
        var past=window.scrollY>window.innerHeight*0.6;
        sticky.classList.toggle('is-on', visible.size===0 && past);
      },{threshold:0});
      anchors.forEach(function(a){ so.observe(a); });
      window.addEventListener('scroll',function(){ if(visible.size===0){ sticky.classList.toggle('is-on', window.scrollY>window.innerHeight*0.6); } },{passive:true});
    }

    d.querySelectorAll('[data-open-ask]').forEach(function(b){ b.addEventListener('click',function(e){ e.preventDefault(); var l=d.querySelector('.rr-ask__launcher'); if(l){ l.click(); } }); });
    d.querySelectorAll('[data-qty]').forEach(function(q){
      var input=q.querySelector('input');
      q.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click',function(){
          var v=parseInt(input.value||'0',10)+(b.hasAttribute('data-plus')?1:-1); if(v<0){v=0;} input.value=v;
          var f=input.form; if(f){ f.submit(); }
        });
      });
    });
  });
})();
